var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEReferralProfileHeaderSmallIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "EReferralProfileHeaderSmallIcon",
    "data-name": "Group 4837",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 35,
    viewBox: "0 0 50 35",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3041",
    "data-name": "Rectangle 3041",
    width: 50,
    height: 35,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4842",
    "data-name": "Group 4842",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4841",
    "data-name": "Group 4841",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4840",
    "data-name": "Group 4840",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4839",
    "data-name": "Group 4839",
    transform: "translate(0 0)",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4838",
    "data-name": "Group 4838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EReferralProfileHeaderSmallIcon-2",
    "data-name": "Group 4837",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4564",
    "data-name": "Path 4564",
    d: "M10,0A5,5,0,0,0,5,5V25h5V5H40V25h5V5a5,5,0,0,0-5-5ZM1.5,27.5A1.5,1.5,0,0,0,0,29a6,6,0,0,0,6,6H44a6,6,0,0,0,6-6,1.5,1.5,0,0,0-1.5-1.5Z",
    transform: "translate(0)",
    fill: "#888"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4565",
    "data-name": "Path 4565",
    d: "M10.41,25.206h30v-20h-30ZM36.17,14.212l-6.609,5.945a1.351,1.351,0,0,1-1.423.227,1.319,1.319,0,0,1-.781-1.2V16.531H23.4a3.962,3.962,0,0,0-3.962,3.962,3.121,3.121,0,0,0,.914,2.344,1.136,1.136,0,0,1,.406.8.817.817,0,0,1-.813.813.709.709,0,0,1-.336-.078,8.092,8.092,0,0,1-4.14-7.187,7.261,7.261,0,0,1,7.265-7.266h4.625V7.274a1.319,1.319,0,0,1,2.2-.977l6.609,5.946a1.327,1.327,0,0,1,0,1.968",
    transform: "translate(-0.41 -0.205)",
    fill: "#0d47a1"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEReferralProfileHeaderSmallIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EReferralProfileHeaderSmallIcon.b6d611279f562c977ea1960ea2f25b29.svg";